import { createAction, props } from '@ngrx/store';
import { PermissionEnumKey } from '../../../core/feature-permission.map';
import { FeaturesEnum } from '../../../core/models/enums/features.enum';
import { ModulePermission } from './permission-state.model';

export const setPagePermissions = createAction(
    '[Permission State] Set Page Permissions',
    props<{ pagePermissions: ModulePermission[] }>(),
);

export const resetPermissionState = createAction('[Permission State] Reset Permission State');

export const loadPermissions = createAction('[Permission State] Load Permissions');

export const loadPermissionsSuccess = createAction(
    '[Permission State] Load Permissions Success',
    props<{ pagePermissions: ModulePermission[] }>(),
);

export const loadPermissionsFailure = createAction(
    '[Permission State] Load Permissions Failure',
    props<{ error: any }>(),
);